import React from 'react'
import { LazyLoad } from 'features/common/ui/LazyLoad'
import AuthenticatedRoute from 'app/ui/AuthenticatedRoute'
import { lazy } from 'app/lazy'

const HomePage = lazy(() => import('./HomePage'))

const routes = {
  path: 'home',
  element: (
    <LazyLoad>
      <AuthenticatedRoute element={<HomePage />} />
    </LazyLoad>
  )
}
export default routes
